<header class="app-header glass">
  <div class="header-brand">
    <img src="assets/logo_compteur.png?v=2" alt="Logo de l'application Teréga" class="app-logo-img">
    <div class="app-title">Modif'Index - relevé mensuel compteur</div>
  </div>
  
  <div class="header-actions">
    <div class="user-info" *ngIf="auth.user$ | async as user">
      <!-- <span class="badge type-capsule" style="background-color: var(--info);">Membre</span> -->
      <span class="user-email" [title]="user.email">{{ user.email }}</span>
    </div>
    <button class="btn btn-outline btn-logout" (click)="logout()">
      Déconnexion
    </button>
  </div>
</header>

<main class="app-content">
  <router-outlet></router-outlet>
</main>
